module.exports = __webpack_public_path__ + "img/1.d894f288.jpeg";